import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Button, Typography } from "@mui/material";
import axios from "axios";
import BaseUrl from "../BaseUrl";
import Loader from "../Loader";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import noDataImage from "../Images/Bankruptcy-cuate_blu.svg";

const headCells = [
  {
    id: "name",
    label: "Name",
  },
  {
    id: "calories",
    label: "From Email",
  },
  {
    id: "fat",
    label: "To Email",
  },
  {
    id: "carbs",
    label: "Date",
  },
];

const NotInterestedDeals = ({
  setShowNotInterestedTable,
  setOpenModal,
  notInterestedCampaignId,
  refreshNotInterestedData,
  setCountryTimeSchdule,
}) => {
  const userDetails = JSON.parse(localStorage.getItem("MailSenderuserDetails"));
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [isLoading, setIsLoading] = useState(true);
  const [notInterestedCampaignData, setNotInterestedCampaignData] = useState(
    []
  );

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const getAllNotInterestedCampaignsData = () => {
    setIsLoading(true);
    axios
      .get(
        `${
          BaseUrl.baseurl
        }/email-marketing/automation/get-all-not-interested-campaign/${
          userDetails && userDetails.details._id
        }`,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          console.log("response.data.details", response.data.details);
          let vikki = [];
          response.data.details.map((item) => {
            item.Details.map((val) => {
              val.Reply.map((value) => {
                value.toEmail = val.Email;
                vikki.push(value);
              });
            });
          });
          setNotInterestedCampaignData(vikki);
          setIsLoading(false);
        } else {
          setNotInterestedCampaignData([]);
          setIsLoading(false);
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((err) => console.log("Error"));
  };
  const getNotInterestedCampaignData = () => {
    setIsLoading(true);
    axios
      .get(
        `${
          BaseUrl.baseurl
        }/email-marketing/automation/get-not-interested-campaign/${
          userDetails && userDetails.details._id
        }/${notInterestedCampaignId?.campaignDetails?._id}`,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          let vikki = [];
          response.data.details.Details.map((val) => {
            val.Reply.map((value) => {
              value.toEmail = val.Email;
              vikki.push(value);
            });
          });
          setNotInterestedCampaignData(vikki);
          setIsLoading(false);
        } else {
          setNotInterestedCampaignData([]);
          setIsLoading(false);
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((err) => console.log("Error"));
  };

  // below function is called when notInterestedCampaignId value is not null
  useEffect(() => {
    if (
      notInterestedCampaignId &&
      notInterestedCampaignId.campaignDetails &&
      notInterestedCampaignId.campaignDetails._id !== null
    ) {
      getNotInterestedCampaignData();
    }
  }, [notInterestedCampaignId?.campaignDetails._id]);

  // below function is calling for get all campaign data
  useEffect(() => {
    getAllNotInterestedCampaignsData();
  }, [!refreshNotInterestedData]);

  const emptyRows =
    page > 0
      ? Math.max(0, (1 + page) * rowsPerPage - notInterestedCampaignData.length)
      : 0;
  function changeDateFormat(date) {
    const inputDate = new Date(date);
    const options = { month: "short", day: "numeric", year: "numeric" };
    const formattedDate = inputDate.toLocaleDateString("en-US", options);
    return formattedDate;
  }
  return (
    <div
      style={{
        height: "100%",
        overflow: "auto",
        backgroundColor: "#FFF",
        padding: "8px",
        borderRadius: "5px",
      }}
    >
      <Box sx={{ width: "100%" }}>
        <Paper
          sx={{
            width: "100%",
            borderRadius: "6px",
            border: "1px solid #DDD",
            boxShadow: "none",
          }}
        >
          <Box
            sx={{
              borderBottom: "1px solid #DDD",
              padding: "6px 16px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Button
              disableRipple
              disableElevation
              sx={{
                cursor: "default",
                outline: "none !important",
                borderBottom: "2px solid #1C485F",
                borderRadius: 0,
                color: "#1C485F",
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "transparent",
                },
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              <button
                onClick={() => {
                  setShowNotInterestedTable(false);
                  setCountryTimeSchdule(null);
                }}
              >
                <ArrowBackRoundedIcon />
              </button>
              <Typography
                style={{
                  color: "#1C485F",
                  fontSize: "15px",
                  fontWeight: 700,
                  fontFamily: "Source Sans 3",
                }}
                component="h2"
              >
                All Not Interested Mails
              </Typography>
            </Button>
          </Box>
          <TableContainer>
            <Table
              sx={{ minWidth: 750 }}
              aria-labelledby="tableTitle"
              size="medium"
            >
              {isLoading ? (
                <TableBody>
                  <TableRow>
                    <TableCell
                      colSpan={headCells.length}
                      align="center"
                      sx={{ borderBottom: "0px" }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: "8px",
                          padding: "40px 0px",
                        }}
                      >
                        <Loader />
                      </Box>
                    </TableCell>
                  </TableRow>
                </TableBody>
              ) : notInterestedCampaignData.length > 0 ? (
                <>
                  <TableHead>
                    <TableRow sx={{ backgroundColor: "#FAFAFA" }}>
                      {headCells.map((headCell, index) => (
                        <TableCell
                          key={index}
                          align="left"
                          style={{ fontWeight: "bold", color: "#000" }}
                        >
                          {headCell.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {notInterestedCampaignData
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((campaign, index) => (
                        <TableRow
                          key={index}
                          sx={{
                            backgroundColor:
                              index % 2 !== 0 ? "#FAFAFA" : "#FFF",
                          }}
                          onClick={() =>
                            setOpenModal({
                              title: "All (Replies)",
                              Data: campaign,
                            })
                          }
                          style={{ cursor: "pointer" }}
                        >
                          <TableCell align="left">
                            <p
                              style={{
                                fontFamily: "Source Sans 3",
                                fontSize: "16px",
                                fontStyle: "normal",
                                fontWeight: 700,
                                color: "#1C485F",
                              }}
                            >
                              {campaign.Data.Name !== " "
                                ? campaign.Data.Name
                                : "---"}
                            </p>
                          </TableCell>
                          <TableCell align="left">
                            <p
                              style={{
                                fontFamily: "Source Sans 3",
                                fontSize: "14px",
                                fontStyle: "normal",
                                fontWeight: 400,
                                color: "#868686",
                              }}
                            >
                              {campaign.FromEmail}
                            </p>
                          </TableCell>
                          <TableCell align="left">
                            <p
                              style={{
                                fontFamily: "Source Sans 3",
                                fontSize: "14px",
                                fontStyle: "normal",
                                fontWeight: 400,
                                color: "#868686",
                              }}
                            >
                              {campaign.toEmail}
                            </p>
                          </TableCell>
                          <TableCell align="left">
                            <p
                              style={{
                                fontFamily: "Source Sans 3",
                                fontSize: "14px",
                                fontStyle: "normal",
                                fontWeight: 400,
                                color: "#868686",
                              }}
                            >
                              {changeDateFormat(campaign.Data.Date)}
                            </p>
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </>
              ) : (
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={headCells.length} align="center">
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          flexDirection: "column",
                          gap: "6px",
                        }}
                      >
                        <img
                          src={noDataImage}
                          alt="no-data"
                          style={{ height: "230px", width: "auto" }}
                        />
                        <p
                          style={{
                            color: "#393939",
                            fontSize: "22px",
                            fontWeight: 700,
                            fontFamily: "Source Sans 3",
                            fontStyle: "normal",
                          }}
                        >
                          No data available
                        </p>
                      </div>
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={headCells.length} />
                </TableRow>
              )}
            </Table>
          </TableContainer>
          {isLoading
            ? null
            : notInterestedCampaignData.length > 0 && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                  }}
                >
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={notInterestedCampaignData.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </div>
              )}
        </Paper>
      </Box>
    </div>
  );
};

export default NotInterestedDeals;
